// @module SuiteDB.SDBYMM.SDBYMM
define("SuiteDB.SDBYMM.SDBYMM.View", [
  "suitedb_sdbymm_sdbymm.tpl",

  "SuiteDB.SDBYMM.SDBYMM.Model",
  "Backbone",
  "SCView",
  "jQuery",
  "AjaxRequestsKiller",
], function (
  suitedb_sdbymm_sdbymm_tpl,

  SDBYMMModel,

  Backbone,
  SCViewComponent,
  $,
  AjaxRequestsKiller
) {
  "use strict";
  var SCView = SCViewComponent.SCView;
  // @class SuiteDB.SDBYMM.SDBYMM.View @extends Backbone.View
  function SDBYMMView(options) {
    SCView.call(this);
    var self = this;
    this.template = suitedb_sdbymm_sdbymm_tpl;
    this.options = options || {};
    this.model = options.model ? options.model : SDBYMMModel.getInstance();
    this.env = options.container.getComponent("Environment");
    this.attributes = {
      id: "SDBFindPerfectFitSearchViewId",
      class: "sdb-find-perfect-fit-search-view",
    };
    this.allMakes = [];
    if (!this.allYears) {
      this.model
        .fetch({
          data: {
            action: "/GetYears",
          },
          async: false,
          cache: true,
          killerId: AjaxRequestsKiller.getKillerId(),
        })
        .done(function (data) {
          var response = JSON.parse(data.data);

          var years = response.Years;

          self.allYears = years;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    this.changeOption = function (e) {
      var value = e.target.value;

      if (e.target.id === "find-pf-search-input-YEAR") {
        if (value === "YEAR") {
          this.selectedYear = null;
          this.selectedMake = null;
          this.allMakes = [];
          this.allModels = [];
          this.render();
        } else if (this.selectedYear) {
          this.selectedMake = null;
          self.selectedYear = parseInt(value);

          this.model
            .fetch({
              data: {
                Year: value,
                action: "/GetMakes",
              },
              async: true,
              cache: true,
              killerId: AjaxRequestsKiller.getKillerId(),
            })
            .done(function (data) {
              var response = JSON.parse(data.data);

              self.allMakes = response.Makes;
              self.allModels = [];

              self.render();
            });
        } else if (!this.selectedYear) {
          this.selectedYear = parseInt(value);

          this.model
            .fetch({
              data: {
                Year: value,
                action: "/GetMakes",
              },
              async: true,
              cache: true,
              killerId: AjaxRequestsKiller.getKillerId(),
            })
            .done(function (data) {
              var response = JSON.parse(data.data);

              self.allMakes = response.Makes;

              self.render();
            });
        }
      } else if (e.target.id === "find-pf-search-input-MAKE") {
        var VehicleYearValue = this.$("#find-pf-search-input-YEAR").val();
        this.selectedMake = value;

        if (value === "MAKE") {
          this.allModels = [];
          this.render();
        } else if (this.selectedMake) {
          this.model
            .fetch({
              data: {
                Year: VehicleYearValue,
                VehicleMake: value,
                action: "/GetModels",
              },
              async: true,
              cache: true,
              killerId: AjaxRequestsKiller.getKillerId(),
            })
            .done(function (data) {
              var response = JSON.parse(data.data);
              self.allModels = response.Models;
              self.render();
            });
        }
      }
    };
    this.events = {
      "change #find-pf-search-input-YEAR": "changeOption",
      "change #find-pf-search-input-MAKE": "changeOption",
    };

    this.listenTo(this.model, "change:category", function (newModel) {
      this.render();
    });

    this.getContext = function () {
      self.options = self.getOptions();

      var yearOptions = self.options.find(function (year) {
        return year.name === "YEAR";
      });

      yearOptions.allYears = _.map(self.allYears, function (year) {
        return {
          year: year,
          selected: year === self.selectedYear,
        };
      });

      var makeOptions = self.options.find(function (make) {
        return make.name === "MAKE";
      });

      if (self.allMakes && self.allMakes.length > 0) {
        makeOptions.allMakes = self.allMakes.map(function (make) {
          return {
            make: make.VehicleMakeName,
            makeId: make.VehicleMakeID,
            selected: make.VehicleMakeID === self.selectedMake,
          };
        });
      } else {
        makeOptions.allMakes = self.allMakes;
      }

      var modelsOptions = self.options.find(function (model) {
        return model.name === "MODEL";
      });

      modelsOptions.allModels = self.allModels;

      return {
        options: this.options,
      };
    };
  }
  SDBYMMView.prototype = Object.create(SCView.prototype);
  SDBYMMView.prototype.constructor = SDBYMMView;
  SDBYMMView.prototype.contextDataRequest = ["miscData"];
  SDBYMMView.prototype.validateContextDataRequest = function () {
    return true;
  };

  SDBYMMView.prototype.getOptions = function () {
    try {
      var category = this.model.get("category")
        ? this.model.get("category").name
        : "Vehicle";
      return this.env.getConfig("SDBFindPerfectFit." + category) || [];
    } catch (error) {
      console.error("Error getting options", error);
    }
  };
  return SDBYMMView;
});
